export default (string = ''): string => {
  return string.replace(
    /(^([A-Z]){1}|_([A-Z]){1})/gi,
    (match) => `${match.replace('_', ' ').toUpperCase()}`,
  );
};
